import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cac-to-ltv',
  component: () => import('../../routes/CacLtv.svelte'),
  card: {
    id: 'cac-to-ltv',
    title: 'CAC to LTV Ratio',
    description: 'Calculate customer acquisition cost against lifetime value to measure business sustainability and unit economics.',
    icon: 'group_add',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/cac-to-ltv',
    category: 'Business',
  },
  seo: {
    title: 'CAC to LTV Ratio Calculator – Customer Acquisition Cost Calculator',
    description: 'Free CAC to LTV calculator. Calculate customer acquisition cost against customer lifetime value to measure business sustainability. Understand your unit economics with our free SaaS calculator.',
  },
};

export default meta;
